<div class="overlay">
  <input type="text" [id]="id" [ngModel]="value" (ngModelChange)="writeValue($event)" required />
  <label [for]="id" [class.active]="value">{{ label }}</label>
</div>
